import React from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 mt-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6 py-12 grid gap-8 sm:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Lightning size={22} weight="fill" color="#FF007F" />
            <span className="font-display font-black uppercase tracking-tighter">AffiliatedConnections</span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            The neon bazaar of the best affiliate deals on the web. Discover, share and get connected.
          </p>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Explore</p>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/" className="hover:text-[#00FFFF]">All Deals</Link></li>
            <li><Link to="/submit" className="hover:text-[#00FFFF]">Post Your Link</Link></li>
            <li><Link to="/advertise" className="hover:text-[#00FFFF]">Advertise With Us</Link></li>
            <li><Link to="/buy-platform" className="hover:text-[#00FFFF]">Buy the Platform</Link></li>
            <li><Link to="/register" className="hover:text-[#00FFFF]">Become a Member</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-3">Need help?</p>
          <p className="text-sm text-zinc-400 mb-4">Tap the glowing chat orb in the corner and chat with Connie, our AI assistant, anytime.</p>
          <NewsletterSignup />
        </div>
      </div>
      <div className="border-t border-zinc-800 py-5 text-center text-xs text-zinc-600 font-mono">
        © {new Date().getFullYear()} AFFILIATED CONNECTIONS — ALL DEALS BLAZING.
      </div>
    </footer>
  );
}
